/** 结果页 60px 状态图标（与开户 Success / Reviewing 同源） */

export const ResultSuccessIcon = () => (
  <svg width="60" height="60" viewBox="0 0 60 60" fill="none" stroke="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#account-result-clip-success)">
      <path
        d="M0 30C0 37.9565 3.16071 45.5871 8.7868 51.2132C14.4129 56.8393 22.0435 60 30 60C37.9565 60 45.5871 56.8393 51.2132 51.2132C56.8393 45.5871 60 37.9565 60 30C60 22.0435 56.8393 14.4129 51.2132 8.7868C45.5871 3.16071 37.9565 0 30 0C22.0435 0 14.4129 3.16071 8.7868 8.7868C3.16071 14.4129 0 22.0435 0 30Z"
        fill="#46DD93"
      />
      <path
        d="M24.0851 41.2626C24.4844 41.7021 25.0413 41.9659 25.6343 41.9965C26.2273 42.0272 26.8083 41.8221 27.2508 41.4261L27.3543 41.3286L42.8538 25.5786C43.2633 25.1625 43.4951 24.6034 43.5 24.0196C43.505 23.4357 43.2828 22.8728 42.8804 22.4498C42.4779 22.0267 41.9269 21.7767 41.3435 21.7524C40.7601 21.7282 40.1902 21.9317 39.7541 22.3199L39.6468 22.4219L25.8153 36.4761L19.6653 29.7059C19.2807 29.2824 18.7492 29.0214 18.179 28.9758C17.6087 28.9303 17.0425 29.1036 16.5956 29.4606L16.4876 29.5529C16.0639 29.9375 15.8027 30.4692 15.7571 31.0396C15.7116 31.61 15.8851 32.1764 16.2423 32.6234L16.3346 32.7314L24.0851 41.2626Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="account-result-clip-success">
        <rect width="60" height="60" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ResultFailIcon = () => (
  <svg width="60" height="60" viewBox="0 0 60 60" fill="none" stroke="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#account-result-clip-fail)">
      <path
        d="M0 30C0 37.9565 3.16071 45.5871 8.7868 51.2132C14.4129 56.8393 22.0435 60 30 60C37.9565 60 45.5871 56.8393 51.2132 51.2132C56.8393 45.5871 60 37.9565 60 30C60 22.0435 56.8393 14.4129 51.2132 8.7868C45.5871 3.16071 37.9565 0 30 0C22.0435 0 14.4129 3.16071 8.7868 8.7868C3.16071 14.4129 0 22.0435 0 30Z"
        fill="#FF4E4E"
      />
      <rect
        x="17.7275"
        y="20.8135"
        width="4.54545"
        height="31.4224"
        rx="2.27273"
        transform="rotate(-45 17.7275 20.8135)"
        fill="white"
      />
      <rect
        width="4.54545"
        height="31.4224"
        rx="2.27273"
        transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 43.1602 20.8135)"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="account-result-clip-fail">
        <rect width="60" height="60" rx="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

/** 审批中 / 已提交：蓝底时钟（与结果页 60px 圆角规格一致） */
export const ResultPendingIcon = () => (
  <svg width="60" height="60" viewBox="0 0 60 60" fill="none" stroke="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 30C0 37.9565 3.16071 45.5871 8.7868 51.2132C14.4129 56.8393 22.0435 60 30 60C37.9565 60 45.5871 56.8393 51.2132 51.2132C56.8393 45.5871 60 37.9565 60 30C60 22.0435 56.8393 14.4129 51.2132 8.7868C45.5871 3.16071 37.9565 0 30 0C22.0435 0 14.4129 3.16071 8.7868 8.7868C3.16071 14.4129 0 22.0435 0 30Z"
      fill="#1060FF"
    />
    <path
      d="M30 17V30H41"
      stroke="white"
      stroke-width="3.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

/** 已取消：与失败同形，灰底 */
export const ResultCancelledIcon = () => (
  <svg width="60" height="60" viewBox="0 0 60 60" fill="none" stroke="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#account-result-clip-cancelled)">
      <path
        d="M0 30C0 37.9565 3.16071 45.5871 8.7868 51.2132C14.4129 56.8393 22.0435 60 30 60C37.9565 60 45.5871 56.8393 51.2132 51.2132C56.8393 45.5871 60 37.9565 60 30C60 22.0435 56.8393 14.4129 51.2132 8.7868C45.5871 3.16071 37.9565 0 30 0C22.0435 0 14.4129 3.16071 8.7868 8.7868C3.16071 14.4129 0 22.0435 0 30Z"
        fill="#A2A7AD"
      />
      <rect
        x="17.7275"
        y="20.8135"
        width="4.54545"
        height="31.4224"
        rx="2.27273"
        transform="rotate(-45 17.7275 20.8135)"
        fill="white"
      />
      <rect
        width="4.54545"
        height="31.4224"
        rx="2.27273"
        transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 43.1602 20.8135)"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="account-result-clip-cancelled">
        <rect width="60" height="60" rx="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ResultWarningIcon = () => (
  <svg width="60" height="60" viewBox="0 0 60 60" fill="none" stroke="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#account-result-clip-warning)">
      <path
        d="M0 30C0 37.9565 3.16071 45.5871 8.7868 51.2132C14.4129 56.8393 22.0435 60 30 60C37.9565 60 45.5871 56.8393 51.2132 51.2132C56.8393 45.5871 60 37.9565 60 30C60 22.0435 56.8393 14.4129 51.2132 8.7868C45.5871 3.16071 37.9565 0 30 0C22.0435 0 14.4129 3.16071 8.7868 8.7868C3.16071 14.4129 0 22.0435 0 30Z"
        fill="#FF4E4E"
      />
      <path
        d="M30 36.2688C29.0233 36.2688 28.2177 35.504 28.167 34.5286L27.3004 17.8625C27.22 16.3164 28.4519 15.0188 30 15.0188C31.5481 15.0188 32.78 16.3164 32.6996 17.8625L31.833 34.5286C31.7823 35.504 30.9767 36.2688 30 36.2688ZM30 44.9813C29.0933 44.9813 28.3283 44.6838 27.705 44.0888C27.11 43.4938 26.8125 42.7146 26.8125 41.7513C26.8125 40.788 27.1242 40.0088 27.7475 39.4138C28.3708 38.8188 29.1217 38.5213 30 38.5213C30.8783 38.5213 31.6292 38.8188 32.2525 39.4138C32.8758 40.0088 33.1875 40.788 33.1875 41.7513C33.1875 42.7146 32.8758 43.4938 32.2525 44.0888C31.6292 44.6838 30.8783 44.9813 30 44.9813Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="account-result-clip-warning">
        <rect width="60" height="60" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
